<template>
  <div class="row d-flex header-wrapper">
    <div class="">
      <h4 class="title-left bold">{{ title }}</h4>
    </div>
    <div class="col-md-6 offset-md-1">
      <h4 class="title-right" v-if="page">{{ page }}</h4>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: ["title", "page"],
});
</script>

<style lang="scss">
.header-wrapper {
  margin-top: 30px !important;
  max-width: 100vw !important;
  @media (min-width: 768px) {
    margin-left: 2vw !important;
  }
}
</style>
